import standardApiRequestAction from 'my-core/standardApiRequestAction';

export function fetchStudySessionBundles(fetchParams, requestKey, page, cacheGroupKey) {
  return standardApiRequestAction({
    path: '/api/v1/study_session_bundles',
    body: fetchParams,
    parentRequestKey: requestKey,
    requestKey: page,
    cacheGroupKey,
  });
}

export function fetchStudySessionBundle(id, fetchParams, requestKey) {
  return standardApiRequestAction({
    path: `/api/v1/study_session_bundles/${id}`,
    body: fetchParams,
    requestKey,
  });
}

export function createStudySessionBundle(body) {
  return standardApiRequestAction({
    path: '/api/v1/study_session_bundles',
    method: 'post',
    body,
  });
}

export function updateStudySessionBundle(id, body) {
  return standardApiRequestAction({
    path: `/api/v1/study_session_bundles/${id}`,
    method: 'patch',
    body,
  });
}

export function deleteStudySessionBundle(id) {
  return standardApiRequestAction({
    path: `/api/v1/study_session_bundles/${id}`,
    method: 'delete',
    destroy: { studySessionBundles: [id] },
  });
}

export function cloneStudySessionBundle(id, body) {
  return standardApiRequestAction({
    path: `/api/v1/study_session_bundles/${id}/clone`,
    method: 'put',
    body,
  });
}

export function fetchStudySessionBundleUsers(id, fetchParams, requestKey) {
  return standardApiRequestAction({
    path: `/api/v1/study_session_bundles/${id}/users`,
    body: fetchParams,
    requestKey,
  });
}

export function confirmStudySessionBundlePurchase(id, paymentIntentId, discountCodeId) {
  return standardApiRequestAction({
    path: `/api/v1/study_session_bundles/${id}/confirm_purchase`,
    method: 'post',
    body: { payment_intent_id: paymentIntentId, discount_code_id: discountCodeId },
  });
}
